module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/step-3-f3558954413dd446bd2cf325752e9e88.png";